import {UI} from "../../../stem-core/ui/UIBase.js";
import {styleRule, StyleSheet} from "../../../stem-core/ui/Style";
import {autoredraw} from "../../../stem-core/decorators/AutoRedraw";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {ProgressBar} from "../../../stem-core/ui/ProgressBar.jsx";
import {Level} from "../../../stem-core/ui/Constants.js";


class TaskProgressStatusDescriptorStyle extends StyleSheet {
    @styleRule
    container = {
        width: 480,
    }

    @styleRule
    messageArea = {
        fontWeight: "bold",
        display: "flex",
        alignItems: "center"
    }
}

interface TaskProgressStatusDescriptorOptions {
    // A progress object, not a status string - it answers getStatusMessage()/ratioDone()
    status?: any;
}

@autoredraw
@registerStyle(TaskProgressStatusDescriptorStyle)
export class TaskProgressStatusDescriptor extends UI.Element<TaskProgressStatusDescriptorOptions> {
    render() {
        const {styleSheet} = this;
        const {status} = this.options;

        return [
            <div className={styleSheet.messageArea}>
                <div>{status.getStatusMessage()}</div>
                <div style={{flex: 1}}/>
                <div>{status.getProgressMessage()}</div>
            </div>,
            <ProgressBar level={status.errorMessage ? Level.PRIMARY : Level.ERROR} value={status.getProgressValue()}/>
        ];
    }
}

// export function RenderSummaryListEntry(entry, depth, {color=Theme.props.COLOR_PRIMARY}={}) {
//
// }
//
// export function RenderSummaryList(entries, depth = 0) {
//     entries.map(entry => {
//         if (Array.isArray(entry)) {
//             return RenderSummaryList(entries, depth + 1);
//         }
//     })
// }